import React, { useState } from 'react';

export const FacebookIcon: React.FC = (): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const fillCol = hover ? '#77A3F9' : '#29335C';

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <circle cx="9" cy="9" r="9" fill="#F7F9FD" />
      <path
        d="M7.58072 5.93668C7.58072 6.18869 7.58072 7.31349 7.58072 7.31349H6.5V8.99705H7.58072V14H9.80076V8.99719H11.2905C11.2905 8.99719 11.43 8.18993 11.4977 7.30728C11.3038 7.30728 9.80915 7.30728 9.80915 7.30728C9.80915 7.30728 9.80915 6.32784 9.80915 6.15616C9.80915 5.98411 10.0512 5.75268 10.2904 5.75268C10.5292 5.75268 11.0332 5.75268 11.5 5.75268C11.5 5.52346 11.5 4.73146 11.5 4C10.8768 4 10.1679 4 9.85541 4C7.52585 3.99988 7.58072 5.68512 7.58072 5.93668Z"
        fill={fillCol}
      />
    </svg>
  );
};
